import { __rest } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { useState, useRef, createContext, useContext } from 'react';
import { ToastContent } from '../../Toast/ToastContent.js';
import { useDoubleEscape } from '../hooks/useDoubleEscape.js';

const DialogContext = /*#__PURE__*/createContext(null);
function useDialogClose() {
  const context = useContext(DialogContext);
  if (!context) {
    throw new Error('useDialogClose must be used within DialogWithDoubleEscape');
  }
  return context.close;
}
function DialogWithDoubleEscape(_a) {
  var {
      onClose,
      onBeforeClose,
      doubleEscapeEnabled = true,
      children,
      className,
      header,
      footer,
      pt
    } = _a,
    dialogProps = __rest(_a, ["onClose", "onBeforeClose", "doubleEscapeEnabled", "children", "className", "header", "footer", "pt"]);
  const [visible, setVisible] = useState(true);
  const toastRef = useRef(null);
  const actualClose = () => {
    setVisible(false);
    onClose();
  };
  const close = () => {
    if (onBeforeClose) {
      onBeforeClose();
    } else {
      actualClose();
    }
  };
  useDoubleEscape({
    onClose: close,
    onShowFeedback: timeWindow => {
      var _a;
      (_a = toastRef.current) === null || _a === void 0 ? void 0 : _a.show({
        severity: 'info',
        summary: 'Info',
        detail: 'Press ESC again to close',
        content: ToastContent,
        life: timeWindow
      });
    },
    enabled: doubleEscapeEnabled
  });
  const handleHide = () => {
    if (!visible) {
      return;
    }
    close();
  };
  return jsxs(DialogContext.Provider, {
    value: {
      close
    },
    children: [jsx(Toast, {
      ref: toastRef,
      position: "top-center",
      baseZIndex: 100
    }), jsx(Dialog, Object.assign({}, dialogProps, {
      visible: visible,
      modal: true,
      draggable: false,
      focusOnShow: false,
      closeOnEscape: false,
      className: className,
      header: header,
      footer: footer,
      closable: false,
      onHide: handleHide,
      pt: pt,
      children: children
    }))]
  });
}

export { DialogWithDoubleEscape, useDialogClose };
